// extracted by mini-css-extract-plugin
export default {"header":"Header_header__1FaCf","menuButton":"Header_menuButton__sshTs","title":"Header_title__U1ntP"};